import { Component, inject, Input, OnInit } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  BreadcrumbListStructuredData,
  StructuredDataModule,
} from '@core/structured-data';
import { LocationService } from '@core/jss-seo';
import { getFieldsFromCustomGraphQL } from '@core/jss-graphql';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import {
  BreadcrumbNavItem,
  BreadcrumbComponent,
} from '@core/navigation-ui/breadcrumb';

import {
  BreadcrumbItem,
  generateStructuredDataFromRoutes,
  mapRouteContext,
} from './breadcrumb-container.helpers';

@Component({
  selector: 'wl-breadcrumb-container',
  templateUrl: './breadcrumb-container.component.html',
  standalone: true,
  imports: [BreadcrumbComponent, StructuredDataModule],
  providers: [LocationService],
})
export class BreadcrumbContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  readonly #env = inject(ENVIRONMENT_CONFIG);
  readonly #location = inject(LocationService);

  structuredData?: BreadcrumbListStructuredData;
  routes: BreadcrumbNavItem[] = [];
  fields?: any;
  showBreadcrumbs = false;

  ngOnInit(): void {
    if (this.rendering) {
      const data = getFieldsFromCustomGraphQL(this.rendering);
      if (data) {
        this.fields = data.fields;
        this.routes = mapRouteContext(
          data.context as BreadcrumbItem,
          this.#env.basePath
        );

        this.structuredData = generateStructuredDataFromRoutes(
          this.routes,
          this.#location.origin
        );

        this.showBreadcrumbs =
          this.fields?.EnableBreadcrumbs?.value && this.routes.length > 0;
      }
    }
  }
}
